import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { EditAccessGroupModalContainer } from "@circle-react/components/SettingsApp/AccessGroups/EditAccessGroupModal/EditAccessGroupModalContainer";
import { MEMBER_EDIT_PATHS } from "@circle-react/components/SettingsApp/AccessGroups/EditAccessGroupModal/constants";
import type { AccessGroupType } from "@circle-react/types/AccessGroup";

interface EditAccessGroupContentType {
  accessGroup: AccessGroupType;
  onClose?: () => void;
}

export const EditAccessGroupModalContent = ({
  accessGroup,
  onClose,
}: EditAccessGroupContentType) => {
  const modal = useModal();

  const handleClose = () => {
    void modal.hide();
    onClose?.();
  };

  return (
    <EditAccessGroupModalContainer
      accessGroup={accessGroup}
      handleClose={handleClose}
      isOpen={modal.visible}
      initialTab={MEMBER_EDIT_PATHS.CONTENT}
    />
  );
};

const EditAccessGroupModal = ModalManager.create(
  ({ accessGroup, onClose }: EditAccessGroupContentType) => (
    <EditAccessGroupModalContent accessGroup={accessGroup} onClose={onClose} />
  ),
);

export const useEditAccessGroupModal = () => useModal(EditAccessGroupModal);
